import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios"; 
import { LangContext } from "../LangContext.jsx";
class TransferRights extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            users:[],
            peopleId:'',
            all:[],
            search:''
        };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e){
        this.setState({all: [], search: e.target.value }, function () {
            this.getUsers();
        });
    }

    componentDidMount() {
        this.getUsers()
    }
    getInitials(name){
        const nameList = name.split(' ')
        return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }
    transfer(user){
        const { lang } = this.context; 
        swal.fire({
            text: lang.get('messages.estas_seguro_que_deseas_transferir_a')  +' ' + user.name+" ?",
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText:lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.transferRights(user);
            }
        });
    }
    async transferRights (user){
        var url = `/api/users/transfer`;
        const res = await axios.post(url,{user:user, peopleId:this.props.peopleId}).then(res=>{
            swal.fire({
                text: "Se han transferido tus derechos",
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-danger",
                },
                timer: 3000
            }).then(function(result) {
                location.reload()
            });

        });
    }

    async getUsers(){
        var url = `/api/users/superadmins`;
        const query = new URLSearchParams();
        if(this.state.search!=''){
            query.append('search', this.state.search)
        }
        const qs = query.toString();
        url = url + `?${qs}`;
        url = url.endsWith('/') ? url.slice(0, -1) : url;
        const res = await axios.get(url);
        this.setState({users: res.data});
    }



    render() {
        const { lang } = this.context; 
        return (
            <div className="modal fade " id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
            <div className="modal-dialog modal50 modal-dialog-centered modal-xl" role="document">
                <div className="modal-content" style={{ background: '#f5f5f5' }}>
                    <div className="modal-body px-15 py-10">
                    <h3 class="card-label font-weight-bolder text-dark">{lang.get('messages.a_quien_deseas_ceder_tus_derechos_como_propietario')}</h3>
                    <div className="input-icon mb-4 mt-5">
                        <input
                            style={{width:'400px'}}
                            onChange={this.handleChange}
                            name="search"
                            type="text"
                            className="form-control"
                            placeholder={lang.get('messages.buscar_usuarios')} />
                        <span>
                            <i className="flaticon2-search-1 text-primary icon-md"></i>
                        </span>
                    </div>
                    {this.state.users.length == 0 && <>{lang.get('messages.no_tienes_usuarios_con_el_rol_de_superadmin_para_ceder_los_derechos')}</>}
                    {this.state.users.length > 0 && <>
                    <table className="table table-borderless m-0 table-valign table-responsive">
                        <thead>
                            <tr>
                                <td colSpan={2}>{lang.get('messages.usuario')}</td>
                                <td> </td>
                                <td> </td>
                            </tr>
                        </thead>
                        <tbody>
                        {this.state.users.map((user, i) => (
                        <tr key={i}>
                            <td style={{width: '1%'}} >
                                <div className="symbol symbol-40">
                                    <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                        {this.getInitials(user.user.name)}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <strong>{user.user.name}</strong>
                                <div className="text-muted">{user.user.email}</div>
                            </td>
                            <td className="text-right">
                            <button onClick={()=> {this.transfer(user.user)} }  class="btn btn-icon btn-light btn-xs"><i class="flaticon2-right-arrow text-primary icon-sm"></i></button>

                            </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                </>}
                        <div className="text-center">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default TransferRights;

if (document.getElementById('TransferRights')) {
    ReactDOM.render(<TransferRights />, document.getElementById('TransferRights'));
}
